import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createFieldFormAction,
  showFieldFormAction,
  updateFieldFormAction,
} from "../../Actions/Section&FieldAction/SectionFieldAction";

const FieldsModal = ({ id = null, closeModal, sectionFormId }) => {
  const dispatch = useDispatch();

  const [errors, setErrors] = useState({});
  useEffect(() => {
    if (id) {
      dispatch(showFieldFormAction(id));
      return;
    } else {
      setInputValue({
        name: "",
        label: "",
        placeholder: "",
        type: "",
      });
      return;
    }
  }, [id]);
  const validate = (values) => {
    let errors = {};
    if (!values.name) {
      errors.name = "Name is required";
    }
    if (!values.label) {
      errors.label = "Label is required";
    }
    if (!values.placeholder) {
      errors.placeholder = "Placeholder is required";
    }
    if (!values.type) {
      errors.type = "Type is required";
    }
    return errors;
  };
  const { field, loading } = useSelector((state) => state.showFields);
  const [inputValue, setInputValue] = useState({
    name: field?.name || "",
    label: "",
    placeholder: "",
    type: "",
  });
  useEffect(() => {
console.log(field)
    if (id) {
      if (field) {
        setInputValue({
          name: field.name,
          label: field.label,
          placeholder: field.placeholder,
          type: field.type,
        });
      }
    } else {
      setInputValue({
        name: "",
        label: "",
        placeholder: "",
        type: "",
      });
    }

  }, [dispatch, id, field]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    if (name === "name") {
      // Regular expression to match only English letters (a-z, A-Z) and spaces
      const englishOnlyRegex = /^[a-zA-Z\s]*$/;
      if (!englishOnlyRegex.test(value)) {
        setErrors({
          ...errors,
          name: "Please enter only English characters.",
        });
        return;
      } else {
        // Clear any previous error for the name field
        setErrors((prevErrors) => {
          const { name, ...rest } = prevErrors;
          return rest;
        });
      }
    }

    setInputValue({
      ...inputValue,
      [name]: value,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const errors = validate(inputValue);
    setErrors(errors);
    if (id) {
      if (Object.keys(errors).length === 0) {
        dispatch(
          updateFieldFormAction(
            id,
            sectionFormId,
            inputValue.name,
            inputValue.type,
            inputValue.label,
            inputValue.placeholder
          )
        );
        closeModal();
      }
    } else {
      if (Object.keys(errors).length === 0) {
        dispatch(
          createFieldFormAction(
            sectionFormId,
            inputValue.name,
            inputValue.type,
            inputValue.label,
            inputValue.placeholder
          )
        );
        closeModal();
      }
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-container lg:w-5/12">
          <div className="modal-header">
            <h3 className="cursor-pointer" onClick={closeModal}>
              X
            </h3>
          </div>
          <form action="" onSubmit={handleSubmit} className="mt-2">
            {/* filed1  */}
            <div className="flex gap-2">
              <div className="flex w-full flex-col">
                <label htmlFor="name">Name *</label>
                <input
                  type="text"
                  name="name"
                  onChange={handleInputChange}
                  value={inputValue.name}
                  className="input w-full"
                  placeholder="Name"
                />
                {errors.name && (
                  <p className="text-red-500 text-base ">{errors.name}</p>
                )}
              </div>
              <div className="flex w-full flex-col">
                <label htmlFor="label">Label *</label>
                <input
                  type="text"
                  name="label"
                  onChange={handleInputChange}
                  value={inputValue.label}
                  className="input w-full"
                  placeholder="Label"
                />
                {errors.label && (
                  <p className="text-red-500 text-base ">{errors.label}</p>
                )}
              </div>
            </div>

            {/* end */}
            {/* filed 2  */}
            <div className="flex w-full gap-2">
              <div className="flex w-full flex-col">
                <label htmlFor="Placeholder">Placeholder *</label>
                <input
                  type="text"
                  name="placeholder"
                  onChange={handleInputChange}
                  value={inputValue.placeholder}
                  className="input w-full"
                  placeholder="Placeholder"
                />
                {errors.placeholder && (
                  <p className="text-red-500 text-base ">
                    {errors.placeholder}
                  </p>
                )}
              </div>
              <div className="flex flex-col w-full">
                <label htmlFor="Type">Type *</label>
                <select
                  onChange={handleInputChange}
                  value={inputValue.type}
                  className="w-full input"
                  name="type"
                  id=""
                >
                  <option value="-1">جۆرەکەی دیاری بکە</option>
                  {["text", "number", "dropdown", "textarea"].map(
                    (select, index) => {
                      return (
                        <option value={select} key={index}>
                          {select}
                        </option>
                      );
                    }
                  )}
                </select>
                {errors.type && (
                  <p className="text-red-500 text-base ">{errors.type}</p>
                )}
              </div>
            </div>
            {/* end */}

            <div className="modal-footer gap-2">
              <button type="submit" className="btn-primary">
                Save
              </button>
              <button className="btn-danger" onClick={closeModal}>
                Close
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FieldsModal;
